@if (showPage()) {
  <div class="table-container">
    <app-datatable [identifier]="'search-patches-table'" [title]="''" [cols]="cols" [rows]="rows" [isloading]="isLoading" [showcheckboxes]="true"
      [total]="total" [isSortable]="true" [currentPage]="pageInfo.pagenum" (onclickcolumn)="sortHotfixes($event)" (pageevent)="onPageChange($event)" [pagination]="true"
      (actionmenuevent)="actionMenuClicked($event)" (onMultiFilterChange)="onMultiFilterChanged($event)"
    [headerColSettings]="cols"></app-datatable>
  </div>
} @else {
  <div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter"></div>
    </div>
    @if (isLoading && !isManifestUpdating) {
      <div class="ot-progress__text" i18n>Loading...</div>
    }
    @if (isManifestUpdating) {
      <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
    }
  </div>
}
